import { getSession } from "@/modules/auth/service";

const getToken = async () => {
  const { data: sessionData } = await getSession();
  return sessionData?.session?.access_token;
};

export default async function getAuthorizationHeader() {
  const token = await getToken();
  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
}
